import React from 'react'
import {
  FlexWrap,
  MainHeading,
} from 'modules/Roles/Partials/ViewCollegeDetails/Partials/Styles/style'
import { EditorContent } from 'components/RichEditor/ContentStyles'

const LeftSection = ({ instituteCampusDetails }) => {
  return (
    <FlexWrap column padding="25px 0">
      <MainHeading>About</MainHeading>
      <EditorContent
        dangerouslySetInnerHTML={{
          __html: instituteCampusDetails?.longDescription || '',
        }}
      />
    </FlexWrap>
  )
}

export default LeftSection
